import { useQuery } from '@tanstack/react-query';
import { getMergeAuditPreview, type MergeAuditPreviewResponse } from '~/api/civilsearch';

/**
 * Fetches the merge audit preview for the selected agency ids, one entry per id in order.
 * The query stays disabled until at least two ids are given.
 */
export function useMergeAuditPreview(agencyIds: string[] | null) {
  const enabled = agencyIds !== null && agencyIds.length >= 2;
  return useQuery<MergeAuditPreviewResponse>({
    queryKey: ['mergeAuditPreview', ...(agencyIds ?? [])],
    queryFn: () => getMergeAuditPreview(agencyIds ?? []),
    enabled,
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}
